(() => {
  const root = document.querySelector('[data-powdi-collection]');
  if (!root) return;

  root.querySelectorAll('[data-powdi-sort]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = select.value;
      if (url) window.location.assign(url);
    });
  });

  const grid = root.querySelector('[data-powdi-collection-grid]');
  const loader = root.querySelector('[data-powdi-collection-loader]');
  if (!grid || !loader) return;

  let nextUrl = loader.dataset.nextUrl || '';
  let loading = false;

  const refreshJudgeMe = () => {
    if (window.jdgm?.customizeBadges) window.jdgm.customizeBadges();
  };

  const loadNext = async () => {
    if (loading || !nextUrl) return;
    loading = true;
    loader.dataset.loading = 'true';

    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error('Collection page failed to load');
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextGrid = doc.querySelector('[data-powdi-collection-grid]');
      const nextLoader = doc.querySelector('[data-powdi-collection-loader]');

      if (nextGrid) {
        nextGrid.querySelectorAll(':scope > *').forEach((node) => {
          grid.appendChild(document.importNode(node, true));
        });
      }

      nextUrl = nextLoader?.getAttribute('data-next-url') || '';
      if (nextUrl) {
        loader.dataset.nextUrl = nextUrl;
      } else {
        loader.hidden = true;
        loader.dataset.nextUrl = '';
      }
      refreshJudgeMe();
    } catch (_error) {
      const fallback = nextUrl
        .replace(/([?&])section_id=[^&]*&?/g, '$1')
        .replace(/[?&]$/, '')
        .replace(/\?&/, '?');
      if (fallback) window.location.assign(fallback);
    } finally {
      loading = false;
      loader.dataset.loading = 'false';
    }
  };

  if (!nextUrl) {
    loader.hidden = true;
    return;
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) loadNext();
      },
      { rootMargin: '480px 0px' }
    );
    observer.observe(loader);
  }
})();
